import 'slick-carousel';

/**
 * Initialize hero slider
 *
 * @return {Void}
 */
$('.js-slider-review').each(function() {
  const $this = $(this);
  const $arrowPrev = $this.find('.js-slider-prev');
  const $arrowNext = $this.find('.js-slider-next');

  $this.find('.js-slides').slick({
    dots: false,
    arrows: true,
    prevArrow: $arrowPrev,
    nextArrow: $arrowNext,
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: false,
    autoplaySpeed: 3000,
    adaptiveHeight: false,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
      // You can unslick at a given breakpoint now by adding:
      // settings: "unslick"
      // instead of a settings object
    ]
  });
})
